// src/lib/consent.js
const CONSENT_KEY = "cookie_consent";

export function getConsent() {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY)) || null;
  } catch {
    return null;
  }
}

export function setConsent(value) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify(value));
  window.dispatchEvent(new Event("consent-updated"));
}